import classes from "./Client.module.css";

const Client = ({ className }) => {
  return (
    <section className={`${className} ${classes.client}`}>
      <div className={classes.headingContainer}>
        <span className={classes.subheading}>OUR CLIENTS</span>
        <h2 className={classes.heading}>我們的客戶</h2>
      </div>
    </section>
  );
};

export default Client;
